import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from "react-leaflet";

function Recenter({ lat, lng }) {
  const map = useMap();
  useEffect(() => {
    if (lat && lng) {
      map.panTo([lat, lng]);
    }
  }, [map, lat, lng]);
  return null;
}

function ClickHandler({ onPick }) {
  useMapEvents({
    click(e) {
      onPick(Number(e.latlng.lat.toFixed(6)), Number(e.latlng.lng.toFixed(6)));
    },
  });
  return null;
}

export const LocationPicker = ({ lat, lng, onPick }) => (
  <div className="h-56 rounded-md overflow-hidden border border-slate-200" data-testid="village-location-picker">
    <MapContainer center={[lat || 39.9334, lng || 32.8597]} zoom={lat ? 11 : 6}
                  style={{ height: "100%", width: "100%" }}>
      <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <ClickHandler onPick={onPick} />
      <Recenter lat={lat} lng={lng} />
      {lat && lng ? <Marker position={[lat, lng]} /> : null}
    </MapContainer>
  </div>
);
